/* eslint-disable */
import React from 'react';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".osui-icon {\n    display: inline-block;\n    width: auto;\n    height: var(--osui-icon-size, 16px); /* osui规范16px */\n    vertical-align: -.125em;\n    fill: currentColor;\n}\n\n.osui-icon-spin {\n    animation: osui-icon-spin 1s infinite linear;\n}\n\n@keyframes osui-icon-spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n";
styleInject(css_248z);

var ESCAPE_MAP = {
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  '&': '&amp;'
};
function escapeHTML(html) {
  return html.replace(/[<>"&]/g, function (c) {
    return ESCAPE_MAP[c] || c;
  });
}

var _excluded = ["className", "title", "spin"];
var baseClassName = 'osui-icon';
function createIcon(_ref) {
  var content = _ref.content,
      width = _ref.width,
      height = _ref.height;
  return function (_ref2) {
    var className = _ref2.className,
        title = _ref2.title,
        spin = _ref2.spin,
        props = _objectWithoutProperties(_ref2, _excluded);

    var iconClasses = [baseClassName, className];

    if (spin) {
      iconClasses.push("".concat(baseClassName, "-spin"));
    }

    var iconClassName = iconClasses.join(' ');
    var tabIndex = props.tabIndex;
    var markup = {
      __html: (title ? "<title>".concat(escapeHTML(title), "</title>") : '') + content
    };
    return /*#__PURE__*/React.createElement("svg", _extends({
      width: width,
      height: height,
      viewBox: "0 0 ".concat(width, " ").concat(height),
      className: iconClassName,
      focusable: tabIndex === '0' ? null : false
      /* eslint-disable react/no-danger */
      ,
      dangerouslySetInnerHTML: markup
      /* eslint-enable react/no-danger */

    }, props));
  };
}

/* eslint-disable */
var IconArrowDownOutlined = createIcon({
  name: 'icon-arrow-down-outlined',
  content: '<path d="M828.248 516.524l-315.42 315.42-45.05-45.05 315.42-315.42z"/><path d="M242.013 471.155l315.42 315.42-45.05 45.05-315.42-315.42z"/><path d="M481.732 767.84V130.629h63.722v637.213z"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconArrowLeftOutlined = createIcon({
  name: 'icon-arrow-left-outlined',
  content: '<path d="M509.451 827.356l-315.42-315.42 45.051-45.05 315.42 315.42z"/><path d="M554.31 241.503l-315.42 315.42-45.05-45.05 315.42-315.42z"/><path d="M258.07 480.458h637.213v63.721H258.071z"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconArrowUpOutlined = createIcon({
  name: 'icon-arrow-up-outlined',
  content: '<path d="M197.408 509.515l315.42-315.42 45.051 45.05-315.42 315.42z"/><path d="M783.134 553.483l-315.357-315.42 45.051-44.988 315.42 315.42z"/><path d="M544.18 258.07v637.213h-63.722V258.071z"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconBranchDropdown = createIcon({
  name: 'icon-branch-dropdown',
  content: '<path d="M511.667 682.667c81.066 0 145.066-55.467 166.4-128H853c25.6 0 42.667-17.067 42.667-42.667S878.6 469.333 853 469.333H678.067c-17.067-72.533-85.334-128-166.4-128-81.067 0-145.067 55.467-166.4 128H170.333c-25.6 0-42.666 17.067-42.666 42.667s17.066 42.667 42.666 42.667h174.934c21.333 72.533 85.333 128 166.4 128zM426.333 512c0-46.933 38.4-85.333 85.334-85.333C558.6 426.667 597 465.067 597 512s-38.4 85.333-85.333 85.333c-46.934 0-85.334-38.4-85.334-85.333z" fill="currentColor" fill-rule="evenodd"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconBranchFilter = createIcon({
  name: 'icon-branch-filter',
  content: '<path d="M810.667 469.333c0-72.533-55.467-128-128-128-72.534 0-128 55.467-128 128 0 55.467 34.133 102.4 85.333 119.467V640c0 46.933-38.4 85.333-85.333 85.333H460.8c-12.8-38.4-42.667-64-81.067-76.8V375.467c55.467-17.067 89.6-64 89.6-119.467 0-72.533-55.466-128-128-128-72.533 0-128 55.467-128 128 0 55.467 38.4 102.4 85.334 119.467v273.066c-51.2 17.067-85.334 64-85.334 119.467 0 72.533 55.467 128 128 128 55.467 0 102.4-34.133 119.467-85.333h93.867c93.866 0 170.666-76.8 170.666-170.667v-51.2c51.2-17.067 85.334-64 85.334-119.467zm-469.334-256C366.933 213.333 384 230.4 384 256s-17.067 42.667-42.667 42.667S298.667 281.6 298.667 256s21.333-42.667 42.666-42.667zm0 597.334c-25.6 0-42.666-17.067-42.666-42.667s17.066-42.667 42.666-42.667C366.933 725.333 384 742.4 384 768s-17.067 42.667-42.667 42.667zM682.667 512c-25.6 0-42.667-17.067-42.667-42.667s17.067-42.666 42.667-42.666 42.666 17.066 42.666 42.666c0 25.6-17.066 42.667-42.666 42.667z" fill="currentColor" fill-rule="evenodd"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconCaretDownOutlined = createIcon({
  name: 'icon-caret-down-outlined',
  content: '<path fill="currentColor" d="M768 349H256l256 325z" fill-rule="evenodd"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconCaretRightOutlined = createIcon({
  name: 'icon-caret-right-outlined',
  content: '<path fill="currentColor" d="M349.5 255.5v512l325-256z" fill-rule="evenodd"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconCheckCircleFilled = createIcon({
  name: 'icon-check-circle-filled',
  content: '<path d="M449.856 706.56l-45.44-45.056.128-.064L268.16 526.016l45.12-45.44L449.6 616.064 720.192 343.68l45.376 45.056-315.712 317.888zM510.528 64A448 448 0 10960 510.528 448 448 0 00510.528 64z" fill="currentColor"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconCheckCircleOutlined = createIcon({
  name: 'icon-check-circle-outlined',
  content: '<path d="M513.593 955.818a446.049 446.049 0 01-316.057-764.654A442.225 442.225 0 01509.77 63.72a446.049 446.049 0 01446.048 446.05A446.049 446.049 0 01509.77 955.818zm0-828.376h-3.823a382.327 382.327 0 000 764.655A382.327 382.327 0 00892.097 509.77 382.327 382.327 0 00509.77 127.442z"/><path d="M406.605 656.01l314.4-316.503 45.243 44.923-314.465 316.503z"/><path d="M315.42 475.806l180.777 179.63-44.923 45.243-180.777-179.694z"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconCheckOutlined = createIcon({
  name: 'icon-check-outlined',
  content: '<path d="M395.709 781.222l495.623-495.687 45.051 45.05L440.76 826.21z"/><path d="M169.88 465.738l315.42 315.42-45.114 45.051-315.42-315.42z"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconCheckSquareFilled = createIcon({
  name: 'icon-check-square-filled',
  content: '<path d="M1024 0v1024H0V0h1024zM805.823 218L398.529 625.294l-181.02-181.02L127 534.784l181.02 181.019 90.509 90.51L896.332 308.51 805.822 218z" fill="currentColor" fill-rule="evenodd"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconCloseCircleFilled = createIcon({
  name: 'icon-close-circle-filled',
  content: '<path d="M667.904 704.32L508.992 546.56 351.104 705.472l-45.376-45.056L463.552 501.44 304.64 343.488l45.12-45.376 158.912 157.824L666.56 297.088 712 342.144 553.984 501.12 712.96 659.008l-45.12 45.44zM510.528 64a448 448 0 102.944 896 448 448 0 00-2.944-896z" fill="currentColor"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconCloseCircleOutlined = createIcon({
  name: 'icon-close-circle-outlined',
  content: '<path d="M514.23 944.348a446.049 446.049 0 01-318.606-760.194A446.049 446.049 0 01512.956 52.251 446.049 446.049 0 01959.004 498.3a446.049 446.049 0 01-446.048 446.048zm0-828.375a382.327 382.327 0 000 764.654A382.327 382.327 0 00896.558 498.3 382.327 382.327 0 00514.23 115.973z"/><path d="M669.073 689.91L307.39 330.713l44.924-45.242 361.681 359.324z"/><path d="M713.486 330.076L354.29 691.758l-45.242-44.924 359.324-361.682z"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconCloseOutlined = createIcon({
  name: 'icon-close-outlined',
  content: '<path d="M174.851 804.799l630.84-630.84 45.051 45.05-630.84 630.84z"/><path d="M805.436 849.786l-630.84-630.84 45.051-45.05 630.84 630.84z"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconDownOutlined = createIcon({
  name: 'icon-down-outlined',
  content: '<path d="M511.681 702.208h.638l315.42-315.42-45.88-45.242-270.178 270.178-270.178-270.178-45.242 45.242 315.42 315.42z"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconExclamationCircleFilled = createIcon({
  name: 'icon-exclamation-circle-filled',
  content: '<path d="M512 64a448 448 0 110 896 448 448 0 010-896zm0 627.2a38.4 38.4 0 100 76.8 38.4 38.4 0 000-76.8zM544 256h-64v349.12h64V256z" fill="currentColor"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconFilterOutlined = createIcon({
  name: 'icon-filter-outlined',
  content: '<path d="M128 128l288.832 319.936L422.08 768l187.008 128V447.936L896 128H128zm356.224 579.456l-4.736-270.528-.384-20.928-13.888-16.448L256 192h512L560.64 399.552l-14.272 16.832V768l-62.144-60.544z"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconGitFilter = createIcon({
  name: 'icon-git-filter',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M943.107 472.092L551.88 80.9c-22.51-22.532-59.05-22.532-81.588 0l-81.233 81.244L492.102 265.19c23.955-8.088 51.412-2.665 70.498 16.425 19.185 19.21 24.569 46.902 16.278 70.938l99.314 99.318c24.028-8.28 51.75-2.93 70.935 16.29 26.823 26.817 26.823 70.27 0 97.093-26.827 26.832-70.278 26.832-97.12 0-20.169-20.185-25.157-49.82-14.942-74.671l-92.622-92.626-.007 243.743a69.249 69.249 0 0118.16 12.984c26.815 26.813 26.815 70.258 0 97.116-26.823 26.812-70.294 26.812-97.089 0-26.82-26.856-26.82-70.3 0-97.116 6.628-6.617 14.297-11.625 22.48-14.981V393.695a67.747 67.747 0 01-22.485-14.983c-20.314-20.299-25.207-50.115-14.788-75.062l-101.58-101.6-268.23 268.235c-22.538 22.549-22.538 59.089 0 81.622l391.201 391.194c22.523 22.532 59.05 22.532 81.604 0l389.393-389.346c22.53-22.542 22.53-59.094 0-81.63"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconHomeOutlined = createIcon({
  name: 'icon-home-outlined',
  content: '<path d="M512.956 212.829l318.606 265.08v350.467H194.35V477.909l318.606-265.08m0-82.838L130.629 448.597v446.049h764.654V446.049L512.956 127.442z"/><path d="M544.816 512.319h-63.72v191.163h63.72V512.32z"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconInfoCircleFilled = createIcon({
  name: 'icon-info-circle-filled',
  content: '<path d="M512 64a448 448 0 110 896 448 448 0 010-896zm32 354.944h-64V768h64V418.944zM512 256a38.4 38.4 0 10-.128 76.672A38.4 38.4 0 00512 256z" fill="currentColor"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconLeftOutlined = createIcon({
  name: 'icon-left-outlined',
  content: '<path d="M273.49 502.46l318.013 311.652 44.522-44.522-267.13-267.13 267.13-273.491-44.522-44.522z"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconLoading3QuartersOutlined = createIcon({
  name: 'icon-loading-3-quarters-outlined',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M521.496 64.099L512 64C264.576 64 64 264.576 64 512c0 20.504 16.622 37.125 37.125 37.125 20.504 0 37.126-16.621 37.126-37.125 0-206.416 167.333-373.75 373.749-373.75l20.502.55C730.114 149.382 885.749 313.245 885.749 512c0 206.416-167.333 373.75-373.749 373.75-20.504 0-37.125 16.62-37.125 37.125C474.875 943.378 491.496 960 512 960c247.424 0 448-200.576 448-448 0-243.771-194.977-442.83-438.504-447.901z"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconMoreOutlined = createIcon({
  name: 'icon-more-outlined',
  content: '<path d="M512.356 760.889c54.983 0 99.555 44.572 99.555 99.555 0 54.983-44.572 99.556-99.555 99.556-54.983 0-99.556-44.573-99.556-99.556s44.573-99.555 99.556-99.555zm0-348.445c54.983 0 99.555 44.573 99.555 99.556s-44.572 99.556-99.555 99.556c-54.983 0-99.556-44.573-99.556-99.556s44.573-99.556 99.556-99.556zm0-348.444c54.983 0 99.555 44.573 99.555 99.556s-44.572 99.555-99.555 99.555c-54.983 0-99.556-44.572-99.556-99.555C412.8 108.573 457.373 64 512.356 64z" fill="currentColor" fill-rule="evenodd"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconPlusOutlined = createIcon({
  name: 'icon-plus-outlined',
  content: '<path d="M830.287 544.816H193.075v-63.72h637.212z"/><path d="M544.18 194.35v637.212h-63.722V194.35z"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconRightOutlined = createIcon({
  name: 'icon-right-outlined',
  content: '<path d="M702.208 512.319l-315.42-315.42-45.242 45.242 270.178 270.178-270.178 270.178 45.242 45.242 315.42-315.42z"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconSearchOutlined = createIcon({
  name: 'icon-search-outlined',
  content: '<path d="M449.235 799.064A350.467 350.467 0 11799.7 446.05a350.467 350.467 0 01-350.466 353.015zm0-637.212A286.745 286.745 0 10735.98 446.049a286.108 286.108 0 00-286.745-284.197z"/><path d="M670.347 714.06l45.051-45.05 135.217 135.152-45.051 45.05z"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconSwitchCross = createIcon({
  name: 'icon-switch-cross',
  content: '<path d="M760.96 308.352L557.12 511.936l203.712 203.712-45.248 45.248-203.712-203.712-203.584 203.712-45.248-45.248 203.648-203.712L263.04 308.352l45.248-45.248L512 466.56l203.648-203.52 45.248 45.248z"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconSwitchTick = createIcon({
  name: 'icon-switch-tick',
  content: '<path d="M806.784 295.744l45.248 45.184L489.92 702.976l-45.184 45.312-226.24-226.24 45.184-45.184 180.992 180.928z"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconTableSortOutlined = createIcon({
  name: 'icon-table-sort-outlined',
  content: '<path d="M543.76 581v222.615l165.02-165.312 45.294 45.214-242.28 242.71L269 683.89l45.212-45.297L479.76 803.828V581h64zM511.795 97l242.28 242.71-45.296 45.214L543.76 219.612v222.615h-64V219.4L314.212 384.635 269 339.338 511.795 97z" fill="currentColor"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconUpOutlined = createIcon({
  name: 'icon-up-outlined',
  content: '<path d="M512.956 321.155h-.637l-315.42 315.42 45.879 45.88 270.178-270.816 270.178 270.815 45.242-45.879-315.42-315.42z"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconUploadOutlined = createIcon({
  name: 'icon-upload-outlined',
  content: '<path d="M513.664 128L757.76 372.16l-45.248 45.248L545.088 249.92V704h-64V251.072l-168.128 168-45.248-45.184z"/><path d="M896 896h-64v-.32H192v.32h-64V640h64v191.68h640V640h64v256z"/>',
  width: 1024,
  height: 1024
});

/* eslint-disable */
var IconVerticalAlignTopOutlined = createIcon({
  name: 'icon-vertical-align-top-outlined',
  content: '<path d="M821.376 330.624h-640v-64h640v64zm-3.52 381.056l-45.696 45.696-271.36-271.36-271.296 271.36-45.632-45.696 316.8-316.736.128.192.256-.192 316.8 316.8z"/>',
  width: 1024,
  height: 1024
});

export { IconArrowDownOutlined, IconArrowLeftOutlined, IconArrowUpOutlined, IconBranchDropdown, IconBranchFilter, IconCaretDownOutlined, IconCaretRightOutlined, IconCheckCircleFilled, IconCheckCircleOutlined, IconCheckOutlined, IconCheckSquareFilled, IconCloseCircleFilled, IconCloseCircleOutlined, IconCloseOutlined, IconDownOutlined, IconExclamationCircleFilled, IconFilterOutlined, IconGitFilter, IconHomeOutlined, IconInfoCircleFilled, IconLeftOutlined, IconLoading3QuartersOutlined, IconMoreOutlined, IconPlusOutlined, IconRightOutlined, IconSearchOutlined, IconSwitchCross, IconSwitchTick, IconTableSortOutlined, IconUpOutlined, IconUploadOutlined, IconVerticalAlignTopOutlined, createIcon };
//# sourceMappingURL=index.js.map
